// importer la librairie de react
import React, { useEffect, useState } from "react"
import { DialogType } from "@front-apps/core/models/dialog"
import DialogService from "@front-apps/core/services/dialog"
import QRCode from "react-qr-code"
import { CwComponentConfig } from "../../models/pageConfig"
import { PageConfig } from "@front-apps/core/models/pageConfig"
import DynamicParamsService from "@front-apps/core/services/dynamicParams"
const CwQrCode = (
    props: PageConfig<CwComponentConfig.QrCode>
): React.JSX.Element => {
    const { config } = props

    const className = config.className || ""
    const [value, setValue] = useState(config.value || "")
    const resolveValue = () => {
        DynamicParamsService.resolve([config.value]).then(
            (result) => {
                if (result) {
                    setValue(result[0] as string)
                }
            },
            (err) => {
                console.error(err)
            }
        )
    }
    useEffect(() => {
        // premier init
        resolveValue()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])
    useEffect(() => {
        let subId: string | null = null
        // on s'abonne aux changements de route
        if (config.useRefreshListener)
            subId = DialogService.getInstance().subscribe(
                "pageRefesh",
                DialogType.REFRESH,
                props.name,
                () => {
                    resolveValue()
                }
            )

        // unsubscribe
        return () => {
            if (subId) DialogService.getInstance().unsubscribe(subId)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])
    return (
        <div className={className}>
            <QRCode
                style={{
                    height: "auto",
                    maxWidth: "100%",
                    width: "100%",
                }}
                value={value}
                viewBox={`0 0 500 500`}
                fgColor={config.fgColor || "#000000"}
            />
        </div>
    )
}
export default CwQrCode
